exports.components = {
  "component---src-pages-classic-js": () => import("./../../../src/pages/classic.js" /* webpackChunkName: "component---src-pages-classic-js" */),
  "component---src-pages-en-index-js": () => import("./../../../src/pages/en/index.js" /* webpackChunkName: "component---src-pages-en-index-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

